<div class="timepicker-selectors">
  <div class="timepicker-value" (click)="toggleDrpDown()">
    <div>{{ selectedTime.hr }}</div>
    <span class="timepicker-selector-seperator">:</span>
    <div>{{ selectedTime.min }}</div>
  </div>
  <signals-time-selector-drp-down
    #timePickerSelector
    [timepickerID]="timepickerID"
    (onTimeChanged)="timeChanged($event)"
    [selectedTime]="selectedTime"
    *ngIf="showDrp"
  ></signals-time-selector-drp-down>
</div>
